export default {
  addressFound:
    "Please review the address details below and provide either the house number, flat number or house name.",
  addressNotfound:
    "Unable to find address from postcode provided. Please enter your address details.",
  pafError:
    "Find address not working. Please enter your address details manually."
};
